module.exports = __webpack_public_path__ + "img/side_of_mouth.5108feed.svg";